'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { ShieldCheck, Mail, Lock, KeyRound, ArrowRight } from 'lucide-react';

export default function Login() {
  const [step, setStep] = useState<'credentials' | '2fa'>('credentials');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [twoFa, setTwoFa] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      if (step === 'credentials') {
        setStep('2fa');
      } else {
        router.push('/admin/dashboard');
      }
    }, 1000);
  };

  return (
    <div className="login-container animate-fade-in">
      <div className="login-box">
        <div className="login-header">
          <div className="login-icon-wrapper">
            <ShieldCheck size={32} />
          </div>
          <h1 className="login-title">PayTaara Admin</h1>
          <p className="login-subtitle">Secure portal for platform operations</p>
        </div>

        <div className="card login-card">
          <form onSubmit={handleLogin} className="login-form">
            {step === 'credentials' ? (
              <>
                <div className="input-group">
                  <label>Admin Email</label>
                  <div className="input-wrapper">
                    <Mail className="input-icon" size={18} />
                    <input 
                      type="email" 
                      required 
                      placeholder="admin@paytaara.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                <div className="input-group">
                  <div className="input-header">
                    <label>Password</label>
                    <a href="#" className="forgot-password">Forgot password?</a>
                  </div>
                  <div className="input-wrapper">
                    <Lock className="input-icon" size={18} />
                    <input 
                      type="password" 
                      required 
                      placeholder="••••••••"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                </div>
              </>
            ) : (
              <div className="input-group animate-fade-in">
                <label>2FA Code</label>
                <p className="input-hint">Enter the 6-digit code from your authenticator app.</p>
                <div className="input-wrapper">
                  <KeyRound className="input-icon" size={18} />
                  <input 
                    type="text" 
                    required 
                    maxLength={6}
                    className="input-2fa" 
                    placeholder="000000"
                    value={twoFa}
                    onChange={(e) => setTwoFa(e.target.value.replace(/\D/g, ''))}
                  />
                </div>
              </div>
            )}

            <button 
              type="submit" 
              className="btn btn-primary login-btn"
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="opacity-70">Processing...</span>
              ) : (
                <>
                  {step === 'credentials' ? 'Verify Credentials' : 'Login to Portal'}
                  <ArrowRight size={18} />
                </>
              )}
            </button>
          </form>
        </div>

        <div className="login-footer">
          <p>Protected by advanced threat monitoring.</p>
          <p>&copy; {new Date().getFullYear()} PayTaara Operations.</p>
        </div>
      </div>
    </div>
  );
}
